<mat-slide-toggle
  #toggleSlider="dynamicPopAnchor"
  [ngModel]="isIPv4Enabled()"
  (ngModelChange)="changeToggleState($event)"
  (change)="toggleSlider.open();"
  [zuiDynamicPopAnchor]="confirmPop.popRef()">
  <span class="fx:font-medium">Shared IPv4 included in the CNAME</span>
</mat-slide-toggle>

<zui-confirm-pop
  #confirmPop
  [heading]="state.sharedIPv4 ? state.translations.disableText : state.translations.enableText"
  [confirmButtonText]="'general.confirm' | transloco"
  [verticalAlign]="'below'"
  [closeButtonText]="'general.close' | transloco"
  (confirm)="onEnableSharedIPv4$.next(!state.sharedIPv4); confirmPop.popRef().close();"
  (closeTrigger)="changeToggleState(state.sharedIPv4);"
/>
